// extracted by mini-css-extract-plugin
module.exports = {"slideItemContainer":"Q_b6","reportsContainer":"Q_b7","reportsSection":"Q_b8","title":"Q_S","cardsPairContainer":"Q_b9"};